<sp-custom-button
    showFontSettings
    showHoverSettings
    [isAdvancedRadius]="isAdvancedRadius"
    [parentBase]="parentBase"
    [parentHover]="parentHover"
    [buttonMode]="buttonMode"
    [isIndependentCorners]="isIndependentCorners"
    [radiusSettings]="radiusSettings"
    [advancedBorderSettings]="advancedBorderSettings"
    [colorsPreset]="selectedThemeColors()"
    (valueChangeEvent)="valueChangeEvent.emit($event)"
></sp-custom-button>
